import { pt } from '@/i18n/locales/pt.js';
import { en } from '@/i18n/locales/en.js';

export const generateMetaTags = (title, description, keywords, ogImage, ogUrl) => {
  return {
    title,
    description,
    keywords,
    ogImage,
    ogUrl
  };
};

export const generateSchemaMarkup = (type, data) => {
  return {
    "@context": "https://schema.org",
    "@type": type,
    ...data
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export const generateToolApplicationSchema = (converterName, description, category, url) => {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": converterName,
    "description": description,
    "applicationCategory": category || "UtilityApplication",
    "operatingSystem": "All",
    "url": url,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "BRL"
    }
  };
};

export const generateConverterSchema = (metadata) => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": metadata.title,
        "description": metadata.description,
        "articleBody": metadata.longDescription,
        "keywords": metadata.keywords,
        "dateModified": "2026-06-11",
        "author": {
          "@type": "Organization",
          "name": "TudoConversor"
        },
        "publisher": {
          "@type": "Organization",
          "name": "TudoConversor",
          "logo": {
            "@type": "ImageObject",
            "url": "https://tudoconversor.com.br/logo.png"
          }
        }
      },
      {
        "@type": "WebApplication",
        "name": metadata.h1 || metadata.title,
        "description": metadata.description,
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "url": metadata.canonicalUrl,
        "offers": {
          "@type": "Offer",
          "price": "0.00",
          "priceCurrency": "BRL",
          "availability": "https://schema.org/InStock"
        }
      }
    ]
  };
};

export const generateCategorySchema = (categoryName, description, url, converters) => {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": categoryName,
    "description": description,
    "url": url,
    "hasPart": converters.map(c => ({
      "@type": "WebPage",
      "name": c.name,
      "url": `https://tudoconversor.com.br/conversor/${c.id}`
    }))
  };
};

export const generateFAQSchema = (questions) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions.map(q => ({
      "@type": "Question",
      "name": q.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": q.answer
      }
    }))
  };
};

export const getHomePageMetadata = (dict = pt) => {
  return {
    title: dict.seo.homeTitle,
    description: dict.seo.homeDescription,
    h1: dict.home.heroTitle,
    content: dict.home.heroContent,
    keywords: 'converter unidades, conversor online, conversor de medidas, transformar unidades'
  };
};